import React from 'react'
import { LeadDetailsResponse } from '../types';

interface InsuranceImageProps {
  lead: LeadDetailsResponse | undefined
}

const InsuranceImage: React.FC<InsuranceImageProps> = ({ lead }) => {

    const image_url = lead?.primary_user_details?.medicare_card_image_url
    const download_url = lead?.primary_user_details?.medicare_card_download_url

    return image_url ? (
        <div style={{

            borderRadius: '0.8rem',
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #E7E7E7'
        }}>
            <img
                src={image_url}
                alt="Medicare card"
                style={{
                    height: '9rem',
                    borderTopLeftRadius: '0.8rem',
                    borderBottomLeftRadius: '0.8rem',
                    minWidth: '10rem'
                }}
            />

            <div style={{ paddingLeft: '2.4rem', paddingTop: '1.7rem', paddingBottom: '1.7rem'}}>
                <div>
                    {`${lead.primary_user_details.first_name} ${lead.primary_user_details.last_name}`}
                </div>
                <div>
                    Insurance Card
                </div>
                {download_url ? (
                    <a
                        href={download_url}
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline', marginTop: '0.4rem', display: 'inline-block' }}
                    >
                        Download
                    </a>
                ) : null}
            </div>
        </div>
    ) : null;
};

export default InsuranceImage;
